import { request } from 'api';
import { VirtualAccountDto } from './types';
import { FileContentDto } from 'types';

export const FinanceService = {
  getVirtualAccount() {
    return request<VirtualAccountDto>('get', '/api/Finance/VirtualAccount');
  },
  getPaymentInvoiceFile(sum: number) {
    return request<FileContentDto>('get', `/api/Finance/PaymentInvoice/File?Sum=${sum}`);
  },
};
